/* RESPONSIBLE TEAM: team-knowledge-foundations */

import type AppService from 'embercom/services/app-service';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class AppsAppArticlesSuggestions extends Route {
  @service declare appService: AppService;

  beforeModel() {
    if (!this.appService.app.canUseArticleSuggestions) {
      this.transitionTo('apps.app.articles.index');
    }
  }
}
